// Module
var code = "<div> <h3>{{vm.error}}</h3> <h3>{{vm.message}}</h3> <div ng-if=\"vm.message.length > 0\"> <a ui-sref=\"app.order\">Order Food</a> </div> </div> ";
// Exports
export default code;